function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolExtractjson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_jsonld2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,25.3v1.5H9.7A5.57,5.57,0,0,1,6.2,26c-.6-.5-.9-1.6-.9-3.1V20.4a2.863,2.863,0,0,0-.6-2.2,2.635,2.635,0,0,0-2.1-.6H2V16.1h.7a2.743,2.743,0,0,0,2.1-.6,4.032,4.032,0,0,0,.6-2.2V10.8c0-1.6.3-2.6.9-3.1a5.332,5.332,0,0,1,3.4-.9h.7V8.3H9.7a2.877,2.877,0,0,0-2,.5,3.513,3.513,0,0,0-.5,2v2.6a4.025,4.025,0,0,1-.5,2.4,2.748,2.748,0,0,1-1.6,1,2.7,2.7,0,0,1,1.7,1,4.94,4.94,0,0,1,.5,2.4v2.6a2.877,2.877,0,0,0,.5,2,2.746,2.746,0,0,0,1.9.5Z",
    style: {
      fill: "#0ca69c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,25.3h.7a2.506,2.506,0,0,0,1.9-.5,2.815,2.815,0,0,0,.4-2V20.2a4.025,4.025,0,0,1,.5-2.4,2.333,2.333,0,0,1,1.7-1,2.7,2.7,0,0,1-1.7-1,4.94,4.94,0,0,1-.5-2.4V10.8a3.444,3.444,0,0,0-.4-2,3.394,3.394,0,0,0-1.9-.5h-.7V6.8h.7a5.57,5.57,0,0,1,3.5.8c.6.5.9,1.6.9,3.1v2.5a2.863,2.863,0,0,0,.6,2.2,2.635,2.635,0,0,0,2.1.6h.7v1.5h-.7a2.743,2.743,0,0,0-2.1.6,2.863,2.863,0,0,0-.6,2.2v2.5c0,1.6-.3,2.6-.9,3.1a5.778,5.778,0,0,1-3.5.8h-.7Z",
    style: {
      fill: "#0ca69c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,19.2c-.1,0-.2-.1-.3-.1h.1s-.6-.3-.7-2.3.6-2.4.6-2.4H20a2.818,2.818,0,1,0-2.6-5,2.752,2.752,0,0,0-1.5,2.9h0s.2.7-1.5,1.8-2.5.5-2.5.5v.1l-.1-.1a2.818,2.818,0,1,0-2.6,5,2.911,2.911,0,0,0,3.1-.3h0s.6-.5,2.4.5c1.4.8,1.6,1.5,1.7,1.8a2.8,2.8,0,1,0,5.6.2,3.076,3.076,0,0,0-1.6-2.6Zm-3.1.4c-.3.1-.9.2-2.3-.6-1.5-.8-1.7-1.5-1.7-1.7v-.7h0s-.1-.6,1.6-1.7c1.5-.9,2.2-.8,2.3-.7a2.01,2.01,0,0,0,.8.4,2.863,2.863,0,0,1,.6,2.2,3.216,3.216,0,0,1-.6,2.3,4.234,4.234,0,0,0-.7.5Z",
    style: {
      fill: "#0c479c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,10.4a2.052,2.052,0,0,0,0,2.9,1.654,1.654,0,0,1,0-1.9.758.758,0,0,1,.4-.2h0a.569.569,0,0,0,.7-.4.749.749,0,0,0-.1-.5,1.657,1.657,0,0,1,2-.2h0A2.082,2.082,0,0,0,17.1,10.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,15.7a2.052,2.052,0,0,0,0,2.9,1.654,1.654,0,0,1,0-1.9.758.758,0,0,1,.4-.2h0a.569.569,0,0,0,.7-.4.749.749,0,0,0-.1-.5,1.657,1.657,0,0,1,2-.2h0A2.082,2.082,0,0,0,8.9,15.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,20.1a2.052,2.052,0,0,0,0,2.9,1.654,1.654,0,0,1,0-1.9.758.758,0,0,1,.4-.2h0a.569.569,0,0,0,.7-.4.749.749,0,0,0-.1-.5,1.657,1.657,0,0,1,2-.2h0A2.171,2.171,0,0,0,17.6,20.1Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolExtractjson);
export default __webpack_public_path__ + "static/media/tool_extractjson.d7b81ce32dc8e57181fb6267d1d54252.svg";
export { ForwardRef as ReactComponent };